'use client';

import Link from 'next/link';
import { Menu } from 'lucide-react';
import { useState } from 'react';

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <nav className="border-b border-border bg-card">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center">
            <Link href="/" className="text-xl font-bold">
              Design Library
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <Link href="/templates" className="hover:text-primary transition-colors">
              Templates
            </Link>
            <Link href="/demos" className="hover:text-primary transition-colors">
              Demos
            </Link>
            <Link href="/categories" className="hover:text-primary transition-colors">
              Categories
            </Link>
          </div>

          <button
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <Menu className="h-6 w-6" />
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden border-t border-border">
          <div className="px-4 py-4 space-y-3">
            <Link
              href="/templates"
              className="block hover:text-primary transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Templates
            </Link>
            <Link
              href="/demos"
              className="block hover:text-primary transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Demos
            </Link>
            <Link
              href="/categories"
              className="block hover:text-primary transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Categories
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
